export const ALERT_VARIANTS = Object.freeze({
  WARN: 'Warning',
  INFO: 'Information',
  SUCCESS: 'Success',
  ERROR: 'Error',
});
